import React from 'react';
import Card from '../../share/cards/Card';

import Team1 from '../../../Assets/Image/png/team.png';
import Team2 from '../../../Assets/Image/png/team2.png';
import Support1 from '../../../Assets/Image/png/support.png';
import Support2 from '../../../Assets/Image/png/support2.png';
import Adobe from '../../../Assets/Image/png/adobe connect.png';
import Skyroom from '../../../Assets/Image/png/skyroom.png';
import snapp from '../../../Assets/Image/png/snapp.png';
import divar from '../../../Assets/Image/png/divar.png';
import OptionPic from '../../../Assets/Image/png/options.png';
import bbb from '../../../Assets/Image/png/BBB.png';
import Table from '../../share/Table/Table';
import { BsCheckLg, BsXLg } from 'react-icons/bs';
import { BtnPrimary, LinkPrimary } from '../../share/buttons/Btn';
import { HashLink, NavHashLink } from 'react-router-hash-link';

const customersImages = [snapp, divar, snapp, divar, snapp, divar];

const Options = () => {
	const cards = [
		{
			pic: Team1,
			title: 'ارتباط بدون مرز',
			content:
				'با شرکت در بوت‌کمپ‌های بوت‌وب با طیف وسیعی از افراد آشنا خواهید شد که در نهایت به ارتباطی بدون مرز منجر خواهد شد',
		},
		{
			pic: Support1,
			title: 'پشتیبانی',
			content:
				'تیم پشتیبانی بوت‌وب همواره و در هر لحظه حامی و پشتیبان شماست تا در صورت مواجه با هر مشکلی، یاری‌رسان شما تا حل کامل مشکل باشد',
		},
		{
			pic: Team2,
			title: 'افزایش مهارت',
			content:
				'در بوت‌کمپ‌های بوت‌وب به افزایش مهارت‌های خود بپردازید و شانس خود را برای برتری در بازار کار بالا ببرید',
		},
		{
			pic: Support2,
			title: 'شبکه‌سازی',
			content:
				'یکی از مهم‌ترین اقدامات برای جذب در یک موقعیت شغلی بهتر، شبکه‌سازی مناسب و آشنایی با افراد صحیح است. در بوت‌وب از این مزیت نیز برخوردار خواهید شد',
		},
	];

	const tableContent = [
		{
			title: 'سازگاری با تمام مرورگرها',
			adobe: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			skyroom: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			bbb: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
		},
		{
			title: 'پشتیبانی کامل از زبان فارسی',
			adobe: <BsXLg className='text-[#B00020] inline-block' />,
			skyroom: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			bbb: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
		},
		{
			title: 'امکان به اشتراک‌گذاری صفحه دسکتاپ',
			adobe: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			skyroom: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			bbb: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
		},
		{
			title: 'امکان ضبط بوت‌کمپ در حین برگزاری',
			adobe: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			skyroom: <BsXLg className='text-[#B00020] inline-block' />,
			bbb: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
		},
		{
			title: 'اپلیکیشن اختصاصی برای سیستم‌عامل‌های مختلف',
			adobe: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			skyroom: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			bbb: <BsXLg className='text-[#B00020] inline-block' />,
		},
		{
			title: 'امکان به اشتراک گذاری فایل در حین ارائه',
			adobe: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			skyroom: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			bbb: <BsXLg className='text-[#B00020] inline-block' />,
		},
		{
			title: 'امکان ایجاد نظرسنجی',
			adobe: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			skyroom: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
			bbb: <BsCheckLg className=' text-[#2E7D32] inline-block' />,
		},
		{
			title: 'حداقل سرعت اینترنت مورد نیاز',
			adobe: '1000kb/s',
			skyroom: '1000kb/s',
			bbb: '1500kb/s',
		},
		{
			title: 'حداکثر ظرفیت',
			adobe: '1000 کاربر آنلاین همزمان',
			skyroom: '3000 کاربر آنلاین همزمان',
			bbb: '150 کاربر آنلاین همزمان',
		},
	];

	const tableHead = [
		{
			title: 'ویژگی مورد نظر',
			pic: null,
		},

		{
			title: 'ادوبی کانکت',
			pic: Adobe,
		},
		{
			title: 'اسکای روم',
			pic: Skyroom,
		},
		{
			title: 'بیگ بلو باتن',
			pic: bbb,
		},
	];
	return (
		<div className=''>
			<div className='flex flex-col justify-center items-center container pb-12'>
				{/* title */}
				<h2 className=' text-[3.2rem] text-primary-dark leading-[6.4rem] mt-[6.7rem] font-bold mb-16'>
					بوت وب، یک بستر مناسب برای برگزاری بوت کمپ‌های تعاملی
				</h2>
				<p className=' text-3xl text-center leading-[3rem] mb-40'>
					در بوت‌کمپ‌های بوت‌وب می‌توانید به تبادل اطلاعات مفید بین خود و
					دیگر اعضا بپردازید تا نه تنها از اتلاف وقت جلوگیری کنید بلکه به
					دور از هر گونه محدودیت زمانی و مکانی در وبینارها شرکت کنید. این
					بوت‌کمپ‌ها در واقع یک گردهمایی یا سمینار تعاملی بر بستر وب است که
					در آن یک بستر تکنولوژیک مناسب، برای انتقال فایل‌های صوتی و تصویری
					و تجارب ایجاد می‌شود.
				</p>
				<div className='flex w-full justify-around gap-10'>
					{cards.map((card, key) => {
						return (
							<Card
								key={key}
								className='flex flex-col container justify-center items-center p-6 '
							>
								<img src={card.pic} className='w-[6.8rem] mb-9' />
								<h5 className=' text-sm font-bold text-primary-dark mb-6'>
									{card.title}
								</h5>
								<p className=' text-xs leading-9 text-right'>
									{card.content}
								</p>
							</Card>
						);
					})}
				</div>
				{/* table */}
				<h3 className=' text-[2.4rem] leading-[6.4rem] mt-[6.7rem] font-[500] mb-16'>
					بسترهای برگزاری بوت کمپ
				</h3>
				<Card className='w-full mb-24'>
					<Table
						header={tableHead}
						content={tableContent}
						className='w-full text-center text-xs'
					/>
				</Card>
				<LinkPrimary to='/price#top' className='px-[14rem] mb-24 py-6'>
					همین حالا بوت‌کمپ خود را بسازید
				</LinkPrimary>
				<div className='flex '>
					<div>
						<h3 className='font-bold text-[2rem] leading-[3.2rem] mb-12'>
							طراحی صفحات لندینگ اختصاصی برای بوت‌کمپ شما
						</h3>
						<p className='leading-[3.15rem] text-[1.8rem] pr-12'>
							با استفاده از داشبورد اختصاصی بوت‌وب می‌توانید درخواست ساخت
							صفحه‌ی لندینگ اختصاصی برای بوت‌کمپ خود دهید تا بدین صورت نه
							تنها شرکت‌کنندگان بیشتری را جذب کنید و در نتیجه درآمد
							بیشتری کسب کنید، بلکه با استفاده از لینک اختصاصی بوت‌کمپ
							خود، به راحتی کاربران را به مقصد اصلی هدایت کنید.
						</p>
					</div>
					<img src={OptionPic} />
				</div>
				<div className='flex flex-col container mb-24'>
					<h2 className='text-md primary-dark items-center flex justify-center mb-8 font-bold'>
						کسب و کارهایی که به ما اعتماد کردند
					</h2>
					<div className='flex justify-between gap-12'>
						{customersImages.map((img, key) => {
							return (
								<Card
									key={key}
									className='w-[21rem] h-[17.3rem] flex items-center justify-center'
								>
									<img src={img} />
								</Card>
							);
						})}
					</div>
				</div>

				<LinkPrimary to='/price#top' className='px-[14rem] mb-24 py-6'>
					همین حالا بوت‌کمپ خود را بسازید
				</LinkPrimary>
				<div className='flex '>
					<div>
						<h3 className='font-bold text-[2rem] leading-[3.2rem] mb-12'>
							داشبورد‌های اختصاصی و مجزای بوت‌وب برای شرکت‌کنندگان و
							برگزار‌کنندگان
						</h3>
						<p className='leading-[3.15rem] text-[1.8rem] pr-12'>
							متخصصین بوت‌وب، با طراحی دو داشبورد مجزا برای شرکت‌کنندگان
							و برگزارکنندگان بوت‌کمپ‌ها، شرایطی را فراهم آورده‌اند تا هر
							کدام از کاربران بسته به نیاز‌هایشان به راحتی از آن استفاده
							کنند و مطمئنا تجربه‌ی کاربری خوبی را برایشان به ارمغان
							خواهد آورد. در هر یک از داشبوردها بخش‌های متفاوت و
							مورد‌نیاز قرار گرفته است که از جمله امکانات آن می‌توان به
							بررسی امور مالی، دوره‌های پیش رو، بخش تیکت و پشتیبانی، بخش
							بوت‌کمپ‌های مورد‌علاقه و حتی بخش مدارک اعطا شده به کاربران
							اشاره کرد که در نوع خود کم‌نظیر است.
						</p>
					</div>
					<img src={OptionPic} />
				</div>
			</div>
		</div>
	);
};

export default Options;
